import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import { getArea, deleteArea } from '../../../actions/homeAction';
import { useDispatch, useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';

const AreaList = () => {
	const dispatch = useDispatch()
	const colorList = useSelector(state => state.home.area)?.response


	useEffect(() => {
		dispatch(getArea())
	},[])

	const columns = [
		{
			name: 'name',
			label: 'Area Name',
			options: {
				filter: true,
				sort: true,
			},
		},
		
		{
			name: 'priority',
			label: 'Priority',
			options: {
				filter: true,
				sort: true,
			},
		},

		{
			name: 'countryId',
			label: 'Actions',
			options: {
				filter: true,
				sort: true,
				customBodyRender: (countryId, tableMeta) => {
					return (
						<div>
							<Link
								to={'/area/add/' + countryId}
								className='m-r-15 text-muted'
								data-toggle='tooltip'
								data-placement='top'
								title=''
								data-original-title='Edit'>
								<i className='f-20 icofont icofont-ui-edit text-custom'></i>
							</Link>
							<span
								onClick={() => {
									if (window.confirm('Delete this area?')) {
										dispatch(deleteArea(countryId));
									}
								}}
								style={{ cursor: 'pointer' }}
								className='m-r-15 text-muted'
								data-toggle='tooltip'
								data-placement='top'
								title=''
								data-original-title='Delete'>
								<i className='f-20 icofont icofont-delete-alt text-danger'></i>{' '}
							</span>
						</div>
					);
				},
			},
		},
	];
	const options = {
		filter: false,
		filterType: 'dropdown',
		viewColumns: false,
		print: false,
		download: false,
		selectableRows: 'none',
	};
	console.log("colorList",colorList);
	
	
  return (
	<div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='page-header'>
							<div className='row align-items-end'>
								<div className='col-lg-8'>
									<div className='page-header-title'>
										<div className='d-inline'>
											<h4>Area List</h4>
										</div>
									</div>
									<Link
										to='/area/add'
										className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
										data-modal='modal-13'>
										{' '}
										<i className='icofont icofont-plus m-r-5'></i> Add Area
									</Link>
								</div>
								<div className='col-lg-4'>
									<div className='page-header-breadcrumb'>
										<ul className='breadcrumb-title'>
											<li className='breadcrumb-item'>
												<Link to='/'>
													<i className='feather icon-home'></i>{' '}
												</Link>
											</li>
											<li className='breadcrumb-item active'>Area List</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div className='page-body'>
							<div className='row'>
								<div className='col-sm-12'>
									<div className='card'>
										<div className='card-block'>
											<div className='dt-responsive table-responsive'>
												<MUIDataTable
													title={'Area List'}
													className='table-responsive'
													data={colorList}
													columns={columns}
													options={options}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
  )
}

export default AreaList